export default __webpack_public_path__ + "static/media/9.fd8e86b0.webp";